import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Who are you?", -1)
const _hoisted_2 = { class: "store-buttons m-top-50" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    class: "modal-store",
    onClose: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          href: _ctx.urls.client,
          target: "_blank",
          class: "link-button m-right-10",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, " Client ", 8, _hoisted_3),
        _createElementVNode("a", {
          href: _ctx.urls.barber,
          target: "_blank",
          class: "link-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, " Barber ", 8, _hoisted_4)
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}